import jexl from 'jexl'
import { GoabPageBlock, GoabBlock, GoabGrid, GoabContainer, GoabDetails, GoabAccordion, GoabCallout, GoabDivider } from "@abgov/react-components";
import { DynamicFields } from "../Forms/DynamicFields";
import { evaluate } from '../../../utils/globalUtility';

export const DynamicCondition = ({ field, form, getResourceValue, getRefData, clickHandlers, context, setFormData }) => {
  return (
      <DynamicFields children={field.fields} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData}></DynamicFields>
  );
};

export const DynamicBlock = ({ field, form, getResourceValue, getRefData, clickHandlers, context, setFormData }) => {
  return (
    <GoabPageBlock {...field.properties}> 
          <DynamicFields children={field.fields} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData}></DynamicFields>
    </GoabPageBlock>
  );
};

export const DynamicGroupBlock = ({ field, form, getResourceValue, getRefData, clickHandlers, context, setFormData }) => {
  return (
    <GoabBlock {...field.properties}> 
          <DynamicFields children={field.fields} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData}></DynamicFields>
    </GoabBlock>
  );
};

export const DynamicGrid = ({ field, form, getResourceValue, getRefData, clickHandlers, context, setFormData }) => {
    return (
      <GoabGrid {...field.properties}>
            <DynamicFields children={field.fields} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData}></DynamicFields>
      </GoabGrid>
    );
};

export const DynamicContaner = ({ field, form, getResourceValue, getRefData, clickHandlers, context, setFormData }) => {
    return (
      <GoabContainer {...field.properties}>
            <DynamicFields children={field.fields} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData}></DynamicFields>
      </GoabContainer>
    );
};

export const DynamicDetails = ({ field, form, getResourceValue, getRefData, clickHandlers, context, setFormData }) => {
  if (field.properties?.heading) {
    field.properties = {...field.properties, heading: getResourceValue({key:'RESOURCES@' + field.properties.heading})};
  }
  return (
    <GoabDetails {...field.properties}>
          <DynamicFields children={field.fields} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData}></DynamicFields>
    </GoabDetails>
  );
};


export const DynamicAccordion = ({ field, form, getResourceValue, getRefData, clickHandlers, context, setFormData }) => {
  if (field.properties?.heading) {
    field.properties = {...field.properties, heading: getResourceValue({key:'RESOURCES@' + field.properties.heading})};
  }
  return (
    <GoabAccordion {...field.properties}>
          <DynamicFields children={field.fields} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData}></DynamicFields>
    </GoabAccordion>
  );
};

export const DynamicCallout = ({ field, form, getResourceValue, getRefData, clickHandlers, context, setFormData }) => {
  if (field.properties?.heading) {
    let heading = getResourceValue({key:'RESOURCES@' + field.properties.heading});
    if (field.properties?.headingParams) {
      // Replace placeholders in the value with provided params
      Object.keys(field.properties?.headingParams || []).forEach((paramKey) => {
          const paramValue = field.properties.headingParams[paramKey];
          const regex = new RegExp(`{${paramKey}}`, 'g');
          let value = getResourceValue({key:'RESOURCES@' + paramValue});
          try {
              const exprValue = jexl.evalSync(paramValue, {...context, form: form});
              if (exprValue) {
                  value = exprValue;
              }
          }
          catch(ex) {
  
          }
          heading = heading.replace(regex, value);
      });
    }
    field.properties = {...field.properties, heading};
  }
  return (
    <GoabCallout {...field.properties}>
          <DynamicFields children={field.fields} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={context} setFormData={setFormData}></DynamicFields>
    </GoabCallout>
  );
};

export const DynamicList = ({ field, form, getResourceValue, getRefData, clickHandlers, context, setFormData }) => {
  const data = evaluate(field.data, {...context, form: form});
  if (!data?.length) {
      return <>{getResourceValue({ key: 'RESOURCES@' + field.data?.noDataLabel })}</>
  }

  return (
    <>
      {data.map((row, index) => {
          return (
            <div key={`row-${index}`}>
              {index > 0 && <GoabDivider mt="l" mb="l"></GoabDivider>}
              <DynamicFields children={field.data.fields} form={form} getResourceValue={getResourceValue} getRefData={getRefData} clickHandlers={clickHandlers} context={{...context, row}} setFormData={setFormData}></DynamicFields>
            </div>
          );
      })}
    </>
  );
};